
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 19","fill":"#55B7A1","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.35 3.64C2.45 3 2.23 1.76 2.86.85c.63-.9 1.88-1.12 2.79-.49.9.64 1.12 1.88.49 2.79-.64.9-1.88 1.12-2.79.49zM14 17H6.93c-1.48 0-2.74-1.08-2.96-2.54L2 5H0l1.99 9.76A5.01 5.01 0 006.94 19H14v-2zm.23-4H9.35L8.32 8.9c1.58.89 3.28 1.54 5.15 1.22V7.99c-1.63.31-3.44-.27-4.69-1.25L7.14 5.47c-.23-.18-.49-.3-.76-.38a2.21 2.21 0 00-.99-.06h-.02a2.268 2.268 0 00-1.84 2.61l1.35 5.92A3.008 3.008 0 007.83 16h6.85l3.82 3 1.5-1.5-5.77-4.5z"}})])
          )
        }
      }
    